import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EstadoPedido, Pedido } from '../models/pedido.model';
import { environment } from 'src/environments/environment';
import { CrearPedidoDTO } from '../models/crearPedido.dto';
import { UpdatePedidoRequest } from '../models/actualizarPedido.model';

@Injectable({
  providedIn: 'root',
})
export class PedidosService {
  constructor(private _http: HttpClient) {}

  crearPedido(dto: CrearPedidoDTO): Observable<Pedido> {
    return this._http.post<Pedido>(`${environment.urlApi}/Orders`, dto, {
      responseType: 'string' as 'json',
    });
  }

  obtenerListadoDePedidos(): Observable<Pedido[]> {
    return this._http.get<Pedido[]>(`${environment.urlApi}/Orders`);
  }

  actualizarPedido(
    pedidoId: number,
    payload: UpdatePedidoRequest,
  ): Observable<Pedido> {
    return this._http.put<Pedido>(
      `${environment.urlApi}/Orders/${pedidoId}`,
      payload,
      { responseType: 'string' as 'json' },
    );
  }

  eliminarPedido(idPedido: number): Observable<string> {
    return this._http.delete<string>(
      `${environment.urlApi}/Orders/${idPedido}`,
      { responseType: 'string' as 'json' },
    );
  }

  actualizarEstadoPedido(
    idPedido: number,
    nuevoEstado: number,
  ): Observable<string> {
    return this._http.patch<string>(
      `${environment.urlApi}/Orders/${idPedido}/status`,
      null,
      { params: { status: nuevoEstado }, responseType: 'string' as 'json' },
    );
  }

  obtenerDetallePedido(id: number): Observable<Pedido> {
    return this._http.get<Pedido>(`${environment.urlApi}/Orders/${id}`);
  }
}
